module.exports = __webpack_public_path__ + "static/developpement-b56dc03ea20a349b8b9cb4411c2c705c.jpg";